import {memo, ShapeComponent, shapeComponent, StyleSheet, Text, View} from "shared/base"
import countryCodes from "./country-codes.json"
import CountryFlag from "react-native-country-flag"
import React from "react"
import UtilsSelect from "components/utils/select"

const styles = StyleSheet.create({
  countryFlag: {marginRight: 5},
  text: {marginLeft: "auto"},
  view: {flexDirection: "row", alignItems: "center", width: "100%"}
})

const countryOptions = countryCodes.map((data) => ({
  content: () => (
    <View style={styles.view}>
      <CountryFlag isoCode={data.code} size={15} style={styles.countryFlag} />
      <Text numberOfLines={1}>
        {data.name}
      </Text>
      <Text style={styles.text}>
        {data.dial_code}
      </Text>
    </View>
  ),
  currentContent: () => (
    <View style={styles.view}>
      <CountryFlag isoCode={data.code} size={15} style={styles.countryFlag} />
      <Text style={styles.text}>
        {data.dial_code}
      </Text>
    </View>
  ),
  code: data.code,
  dialCode: data.dial_code,
  name: data.name,
  text: `${data.name} ${data.dial_code}`,
  value: data.code
}))

export {countryOptions}

export default memo(shapeComponent(class UtilsCountriesSelect extends ShapeComponent {
  render() {
    return (
      <UtilsSelect options={countryOptions} {...this.props} />
    )
  }
}))
